import React from 'react';
import Particles from 'react-particles';
import { Clock, Sparkles } from 'lucide-react';
import { loadSlim } from 'tsparticles-slim';

const ComingSoon = () => {
  const particlesInit = async (engine) => {
    await loadSlim(engine);
  };

  return (
    <div className="flex w-full h-full">
      <div className="flex-shrink-0" />
      <div className="flex-grow relative  bg-gradient-to-br from-gray-50 to-white overflow-hidden">
        <div className="absolute inset-0">
          <Particles
            className="h-full"
            init={particlesInit}
            options={{
              fullScreen: { enable: false },
              particles: {
                number: { value: 100, density: { enable: true, value_area: 800 } },
                color: { value: '#114691' },
                shape: { type: 'circle' },
                opacity: { value: 0.5 },
                size: { value: 3 },
                line_linked: {
                  enable: true,
                  distance: 150,
                  color: '#114691',
                  opacity: 0.3,
                  width: 1
                },
                move: {
                  enable: true,
                  speed: 2,
                  direction: 'none',
                  random: false,
                  straight: false
                }
              },
              interactivity: {
                detect_on: 'canvas',
                events: {
                  onhover: { enable: true, mode: 'grab' },
                  onclick: {
                    enable: true,
                    mode: 'push'
                  },
                  resize: true
                },
                modes: {
                  grab: {
                    distance: 140,
                    line_linked: {
                      opacity: 1
                    }
                  },
                  push: {
                    particles_nb: 4
                  }
                }
              },
              retina_detect: true
            }}
          />
        </div>
        <div className="flex items-center mt-44 justify-center p-4">
          <div className="relative flex flex-col items-center bg-white/90 backdrop-blur-sm p-8 md:p-12 rounded-3xl shadow-2xl max-w-md space-y-8 transform transition-all duration-500 hover:scale-105 hover:shadow-3xl border border-gray-100">
            <div className="absolute -top-6 left-1/2 -translate-x-1/2">
              <div className="relative">
                <Clock className="w-16 h-16 text-brand-700 animate-pulse" />
                <Sparkles className="w-6 h-6 text-brand-700 absolute -top-2 -right-2 animate-bounce" />
              </div>
            </div>
            <div className="mt-8">
              <h2 className="text-5xl font-bold text-gray-800 text-center leading-tight animate-fade-in">
                Coming Soon
              </h2>
              <div className="h-1 w-20 bg-brand-700 mx-auto mt-4 rounded-full" />
            </div>
            <p className="text-lg text-gray-600 text-center leading-relaxed">
              We're crafting something extraordinary. 
              <br />Stay tuned for the big reveal!
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ComingSoon;
